<template>
  <div>
    <div class="d-flex notifySubHeader">
      <div style="cursor: pointer" @click="viewMethod">{{ headerText }}</div>
      <div
        style="cursor: pointer"
        @click="markAllRead"
        v-if="headerText == 'View All'"
      >
        Mark All as read
      </div>
    </div>
    <div v-if="renderingList && renderingList.length > 0">
      <div class="style-3" style="height: 80vh; overflow: auto">
        <div
          v-for="(item, index) in renderingList"
          :key="index"
          class="d-flex notifyDivCls"
          :style="
            item.isRead == false
              ? 'background-color: #f6f6fe;cursor:pointer !important'
              : 'cursor:pointer !important'
          "
        >
          <div class="d-flex">
            <div>
              <div
                class="readCheckCls"
                @click="markRead(item)"
                :style="
                  item.isRead == false
                    ? 'background-color: #5445f3'
                    : 'border: 1px solid #00000066;'
                "
              ></div>
            </div>
            <div class="flex-grow-1" style="margin-left: 5px">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div>
                      <div class="notificationImageDiv">
                        <img
                          v-if="checkItemImage(item)"
                          :src="checkItemImage(item)"
                          :class="
                            item.title != 'Notice'
                              ? 'notificationImage'
                              : 'notificationIcons'
                          "
                        />
                        <b-avatar
                          v-else-if="item.title"
                          :text="pickText(item)"
                          class="align-baseline referrerAvatar"
                          :id="'teamPopover' + item._id + index"
                          :style="`background:${pickBackgroundColor(
                            item.title
                          )};min-width:100%;min-height:100%;border-radius:50%;cursor:pointer`"
                        ></b-avatar>
                        <b-avatar
                          v-else-if="!checkItemImage(item)"
                          :src="checkItemImage(item)"
                          :text="pickText(item)"
                          class="align-baseline referrerAvatar"
                          :id="'teamPopover' + item._id + index"
                          :style="`background:${pickBackgroundColor(
                            pickText(item)
                          )};min-width:100%;min-height:100%;border-radius:50%;cursor:pointer`"
                        ></b-avatar>
                      </div>
                    </div>
                    <div style="margin-left: 10px">
                      <div v-if="item.entityType != 'Documents'">
                        <div
                          v-if="item.title == 'Notice'"
                          class="notifyNoticeText"
                        >
                          {{ item.title }}
                        </div>
                        <div
                          class="notifySubContentCls"
                          @click="navigate(item)"
                        >
                          {{ displayText(item.body) }}
                          <span v-if="item.openMailClient">
                            Email
                            <a href="mailto:founders@fiifi.co" target="_blank"
                              >founders@fiifi.co</a
                            >
                          </span>
                        </div>
                      </div>
                      <div v-else class="notifySubContentCls">
                        <span
                          v-if="item.emailBody && item.emailBody.attachments"
                        >
                          <span
                            v-for="(file, index) in item.emailBody.attachments"
                            :key="index"
                            style="color: #5445f3"
                          >
                            <i
                              title="download"
                              class="fa fa-download"
                              @click="downloadFile(file)"
                            ></i>
                            <span @click="navigate(item, index, 'document')">
                              {{
                                index ==
                                  item.emailBody.attachments.length - 1 && 1
                                  ? file.file_name
                                  : file.file_name + ", "
                              }}
                            </span>
                          </span>
                        </span>
                        <span>
                          &nbsp;
                          {{ documentDisplayText(item) }}
                        </span>
                      </div>
                      <div
                        v-if="item.createTodo"
                        class="createTodoCls"
                        @click="createTodo('tax_session_todo')"
                      >
                        Create To-do
                      </div>
                    </div>
                  </div>
                </div>
                <div style="margin-left: 3px">
                  <div class="notifyTimeCls">
                    {{ getNotificationTime(item.created) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="notifyPlaceholder" v-else>No records to view</div>
    <a class="hidden" ref="hiddlenThisRef" :href="downloadLink" target="_blank"
      >Download Sample</a
    >
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { pickBackgroundColor } from "../../../util/index";
import api from "../../../axios_api";
import config from "../../../../config/settings";
export default {
  data() {
    return {
      notificationList: [],
      unreadList: [],
      notificationByWorkspace: [],
      headerText: "View Unread",
      renderingList: [],
      downloadLink: "",
    };
  },
  computed: {
    ...mapGetters("workspace", ["workspaces"]),
    config() {
      return config;
    },
  },
  methods: {
    displayText(string) {
      if (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      } else return string;
    },
    pickBackgroundColor: pickBackgroundColor,
    async downloadFile(item) {
      console.log(item);
      let self = this;
      if (item.s3_location && item.s3_location.path) {
        let urlData = await api
          .post(`/file/download`, {
            encrypt: {
              data: {
                s3_path: item.s3_location.path,
              },
            },
          })
          .catch((e) => {
            console.error("error: ", e);
          });
        if (
          urlData &&
          urlData.data &&
          urlData.data.encrypt &&
          urlData.data.encrypt.url
        ) {
          this.downloadLink = urlData.data.encrypt.url;

          setTimeout(() => {
            self.$refs.hiddlenThisRef.click();
          });
        }
      }
    },
    pickText(item) {
      if (item.entityType && item.entityType == "Documents") {
        let workspaces = JSON.parse(JSON.stringify(this.workspaces));
        let workspace = workspaces.filter((itm) => {
          if (
            itm &&
            itm.hasOwnProperty("workspace") &&
            itm.workspace.hasOwnProperty("_id") &&
            itm.workspace._id == item.workspace
          ) {
            return itm;
          }
        });
        if (workspace && workspace.length > 0) {
          if (
            workspace[0] &&
            workspace[0].hasOwnProperty("workspace") &&
            workspace[0].workspace.hasOwnProperty("title") &&
            workspace[0].workspace.title
          ) {
            return workspace[0].workspace.title.charAt(0);
          }
        }
        return "U";
      } else if (item.title.toLowerCase() == "todo" && item.body)
        return item.body.charAt(0);
      else return item.title.charAt(0);
    },
    checkItemImage(item) {
      if (item.notified_by && item.notified_by.image) {
        if (item.entityType && item.entityType == "Documents") {
          let workspaces = JSON.parse(JSON.stringify(this.workspaces));
          let workspace = workspaces.filter((itm) => {
            if (
              itm &&
              itm.hasOwnProperty("workspace") &&
              itm.workspace.hasOwnProperty("_id") &&
              itm.workspace._id == item.workspace
            ) {
              return itm;
            }
          });
          if (workspace && workspace.length > 0) {
            if (
              workspace[0] &&
              workspace[0].hasOwnProperty("workspace") &&
              workspace[0].workspace.hasOwnProperty("logo") &&
              workspace[0].workspace.logo
            ) {
              return workspace[0].workspace.logo;
            }
          }
          return "";
        }
        return item.notified_by.image;
      } else if (item.organization && item.organization.logo)
        return this.getImageUrl(item.organization.logo);
      else if (item.title && item.title == "Notice")
        return "static/img/calendar.svg";
      else return "";
    },
    getNotifications() {
      this.notificationByWorkspace = this.$store.getters[
        "notifications/notificationByWorkspace"
      ](this.$route.params.workspace_id);
    },
    getNotificationTime(item) {
      if (item) {
        let givenDate = new Date(item).getTime();
        let now = new Date().getTime();
        let diff = now - givenDate;
        let mins = Math.floor(diff / 60000);
        let hrs = Math.floor(mins / 60);
        let days = Math.floor(hrs / 24);
        let yrs = Math.floor(days / 365);
        if (mins < 1) return `2s`;
        else if (mins < 60) return `${mins}m`;
        else if (hrs < 24) return `${hrs}hr`;
        else if (days < 365) {
          if (days < 31) return `${days}d`;
          var months;
          months =
            (new Date().getFullYear() - new Date(item).getFullYear()) * 12;
          months -= new Date(item).getMonth();
          months += new Date().getMonth();
          return months <= 0 ? 0 : `${months}mo`;
        }
        return `${yrs}y`;
      } else return "";
    },
    navigate(item, index) {
      let self = this;

      if (!item.isRead) {
        this.markRead(item);
      }
      if (
        item.entityType == "Documents" &&
        item.emailBody &&
        item.emailBody.attachments
      ) {

        let attachments = item.emailBody.attachments;
        if(index >= 0) {
          attachments = [item.emailBody.attachments[index]];
        }

        self.$store.commit(
          "notifications/setFileData",
          attachments
        );
      }
      if (item.link) {
        self.$router
          .push(item.link)
          .catch((err) => console.log("Fail to navigate"));
      }
    },
    markRead(item) {
      let self = this;
      if (!item.isRead) {
        self.$store
          .dispatch("notifications/markRead", {
            _id: item._id,
          })
          .then((data) => {
            item.isRead = true;
            // self.renderingList = self.notificationByWorkspace.filter(
            //   (item) => item.isRead == false
            // );
          })
          .catch((err) => {
            console.log("Fail to update notification", { err });
          });
      } else {
        self.$store
          .dispatch("notifications/markUnRead", {
            _id: item._id,
          })
          .then((data) => {
            item.isRead = false;
          })
          .catch((err) => {
            console.log("Fail to update notification", { err });
          });
      }
    },
    markAllRead() {
      let self = this;
      let id = [];
      this.renderingList.map((item) => {
        if (!item.isRead) {
          id.push(item._id);
        }
      });
      if (id.length > 0) {
        self.$store
          .dispatch("notifications/markAllRead", {
            id,
          })
          .then((data) => {
            this.renderingList.map((item) => {
              if (!item.isRead) {
                item.isRead = true;
              }
            });
            //if (!item.isRead) item.isRead = true;
            //self.$router.push(item.link);
            self.renderingList = self.notificationByWorkspace;
            self.headerText = "View Unread";
          })
          .catch((err) => {
            console.log("Fail to update notification", { err });
          });
      }
    },
    viewMethod() {
      if (this.headerText == "View Unread") {
        this.renderingList = this.notificationByWorkspace.filter(
          (item) => item.isRead == false
        );
        this.headerText = "View All";
      } else if (this.headerText == "View All") {
        this.renderingList = this.notificationByWorkspace;
        this.headerText = "View Unread";
      }
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },
    documentDisplayText(item) {
      let name =
        item &&
        item.hasOwnProperty("notified_by") &&
        item.notified_by.hasOwnProperty("firstName")
          ? item.notified_by.lastName &&
            item.notified_by.firstName != item.notified_by.lastName
            ? `${this.capitalizeFirstLetter(
                item.notified_by.firstName
              )} ${this.capitalizeFirstLetter(item.notified_by.lastName)}`
            : this.capitalizeFirstLetter(item.notified_by.firstName)
          : "Unknown";
      let workspace = this.workspaces.find((itm) => {
        if (
          itm &&
          itm.hasOwnProperty("workspace") &&
          itm.workspace.hasOwnProperty("_id") &&
          itm.workspace._id == item.workspace
        ) {
          return itm;
        }
      });
      return `was added to the document section of ${
        this.capitalizeFirstLetter(
          workspace ? workspace.workspace.title : ""
        ) || "Untitled"
      } by ${name}.`;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  mounted() {
    this.renderingList = JSON.parse(
      JSON.stringify(this.notificationByWorkspace)
    );
  },
  watch: {
    notificationByWorkspace: function (newVal) {
      if (newVal) this.renderingList = JSON.parse(JSON.stringify(newVal));
    },
  },
};
</script>
<style>
.notifyPlaceholder {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  color: #707070;
}
</style>